var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{class:{ 'updating-status' : _vm.state },on:{"click":_vm.handleClick}},[_vm._v(" mdi-refresh ")])
}
var staticRenderFns = []

export { render, staticRenderFns }